import React from 'react';
import { useSelector } from 'react-redux';
import Report from './Report';
import Reports from './Reports';
import ReportsMain from './ReportsMain';
import { ReportType } from '../../../constants/system-constants';

function getPageForRoute(key: string) {
    const selected = {
        // 'audit-report': <AuditReport />,
        'transaction-report': <ReportsMain reportType={ReportType.TRANSACTIONAL} key="transactional" />,
        'time-attendance-report': <ReportsMain reportType={ReportType.TIME_AND_ATTENDANCE} key="timeAndAttendance" />,
        // 'timebased-report': <TimebasedReport />,
        // 'realtime-report': <RealtimeReport />,
        // 'privileges-report': <PrivilegesReport />
        'report': <Report />,
        'transaction-reports': <Report reportType={ReportType.TRANSACTIONAL} />,
        'time-attendance-reports': <Report reportType={ReportType.TIME_AND_ATTENDANCE} />
    }[key];
    
    if (selected) {
        return selected;
    }
    return <Reports />
}

function getKeyFromPath(path: string) {
    const contentKey = 3;
    const key = path.split('/')[contentKey];
    return key;
}

const ReportsIndex = () => {
    const page = useSelector((state: any) => state.router.location.pathname);

    return getPageForRoute(getKeyFromPath(page));
}

export default ReportsIndex;
